import { render, staticRenderFns } from "./EditEmpresaPJ.vue?vue&type=template&id=10305c86"
import script from "./EditEmpresaPJ.vue?vue&type=script&lang=js"
export * from "./EditEmpresaPJ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports